import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import GoogleSpreadsheetReaderForm from '../forms/google-spreadsheet-reader-form';
import { googleSpreadsheetReaderValidationSchema } from '../schema/googleSpreadsheetReader.js';

export default function GoogleSpreadsheetReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Google Spreadsheet Reader Node Details',
        altText: 'Google Spreadsheet Reader Node',
        defaultLabel: 'Google Spreadsheet Reader Node',
      }}
    >
      <CommonNode
        FormComponent={GoogleSpreadsheetReaderForm}
        schemaResolver={googleSpreadsheetReaderValidationSchema}
      />
    </NodeProvider>
  );
}
